import {Component} from '@angular/core';
import {AlertController, NavParams, ViewController} from 'ionic-angular';

import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {IMyDateRange, IMyDateRangeModel, IMyDrpOptions} from 'mydaterangepicker';
import {AlertService} from '../../../providers/alert-service';
import {PlanoAcaoService} from '../../../providers/plano-acao-service';
import {GestaoPcaService} from "../../../providers/gestao-pca-service";

/*
  Generated class for the ModaPlanoAcao page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-plano-acao',
  templateUrl: 'modal-plano-acao.html',
  providers: [
    AlertService,
    PlanoAcaoService
  ]
})
export class ModalPlanoAcaoPage {
  PCAAtiva: any;
  titulo: any;
  objeto: any;
  objetoDateRange: any;
  listaAnosPlanoAcao: any[];
  isJurisdicionado: any;
  isCGE: any;
  analistaEditar: any;
  idQuestaoReposta: any;
  planoAcoesAnteriores: any[];
  objetoRetorno: {
    flag: boolean,
    objeto: string
  };


  myDatePickerOptions: IMyDpOptions;
  myDatePickerDataFimOptions: IMyDpOptions;
  myDateRangePickerOptions: IMyDrpOptions;

  selectedDateRange: IMyDateRange;

  selectedText: string = '';
  border: string = 'none';

  placeholderTxt: string = 'Selecione o Período...';

  constructor(private viewCtrl: ViewController, public navParams: NavParams, public planoAcaoService: PlanoAcaoService, public alertCtrl: AlertController, private gestaoPCAService: GestaoPcaService) {
    this.PCAAtiva = this.gestaoPCAService.getPCA();
    this.PCAAtiva.isPCAAberta = this.gestaoPCAService.isPCAAberta();
    this.planoAcoesAnteriores = [];
    this.objetoRetorno = {
      flag: false,
      objeto: ""
    };

    let date = new Date();
    this.myDatePickerOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      disableUntil: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() - 1 }
    };

    this.myDatePickerDataFimOptions = {
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      dateFormat: 'dd/mm/yyyy',
      todayBtnTxt: 'Hoje',
      firstDayOfWeek: 'su',
      disableWeekends: false,
      editableDateField: true,
      openSelectorOnInputClick: true,
      showClearDateBtn: false,
      componentDisabled: true
    };

    this.myDateRangePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      firstDayOfWeek: 'su',
      showApplyBtn: false,
      selectBeginDateTxt: 'Selecione a Data de Início',
      selectEndDateTxt: 'Selecione a Data de Fim',
      openSelectorOnInputClick: true,
      editableDateRangeField: false,
      width: '100%',
      yearSelector: true
    };

    this.titulo = this.navParams.get('param1');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.idQuestaoReposta = this.navParams.get('idquestaoresposta');
    this.obterPlanosAcoesAnteriores();
    this.objeto = {
      dsPlanoAcaoAtual: this.navParams.get('param2').dsPlanoAcao,
      dataInicio: this.navParams.get('param2').dtPlanoInicio,
      dataFim: this.navParams.get('param2').dtPlanoFim
    };

    if (this.objeto.dataInicio != "" && this.objeto.dataFim != "") {
      let inicio = this.objeto.dataInicio.split("/", 3);
      let fim = this.objeto.dataFim.split("/", 3);
      this.objetoDateRange = {
        beginDate: { year: Number.parseInt(inicio[2]), month: Number.parseInt(inicio[1]), day: Number.parseInt(inicio[0]) },
        endDate: { year: Number.parseInt(fim[2]), month: Number.parseInt(fim[1]), day: Number.parseInt(fim[0]) }
      };
    }
  }


  obterPlanosAcoesAnteriores() {
    this.planoAcaoService.obterPlanosAcoes(this.idQuestaoReposta).subscribe(data => {
      if (data != null) {
        this.planoAcoesAnteriores = data;
      }
    }, error => {
      console.log("erro: " + error);
    });
  }

  onDateRangeChanged(event: IMyDateRangeModel) {
    if (event.formatted !== '') {

      this.border = '1px solid #CCC';

      this.objeto.dataInicio = new Date(event.beginJsDate).toLocaleDateString('pt-br');
      this.objeto.dataFim = new Date(event.endJsDate).toLocaleDateString('pt-br');
    }
    else {
      this.selectedText = '';
      this.border = 'none';
    }
  }

  clearDateRange(): void {
    this.selectedDateRange = null;
  }

  onDataInicioChanged(event: IMyDateModel) {
    this.objeto.dataInicio = new Date(event.jsdate).toLocaleDateString('pt-br');

    let copy = this.getCopyOfDataFimOptions();

    copy.componentDisabled = false;
    copy.disableUntil = { year: event.date.year, month: event.date.month, day: event.date.day - 1 };

    this.myDatePickerDataFimOptions = copy;

  }

  getCopyOfDataFimOptions(): IMyDpOptions {
    return JSON.parse(JSON.stringify(this.myDatePickerDataFimOptions));
  }

  onDataFimChanged(event: IMyDateModel) {
    this.objeto.dataFim = new Date(event.jsdate).toLocaleDateString('pt-br');
  }

  dismiss() {
    this.objetoRetorno.flag = false;
    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  salvarPlanoAcao() {
    this.objetoRetorno.flag = true;
    this.objetoRetorno.objeto = this.objeto;
    this.viewCtrl.dismiss(this.objetoRetorno);

    this.mostrarAlerta("", "Plano de ação salvo com sucesso!");
  }


  mostrarAlerta(titulo, subtitulo) {
    let alert = this.alertCtrl.create({
      title: titulo,
      subTitle: subtitulo,
      buttons: ['Ok']
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-plano-acao/modal-plano-acao.ts